<div class="dialog-grid">

    <div class="top">
        <h4>Create a new project</h4>
        <div class="close-icon">
            <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;"
                (click)="cancel()">close
            </mat-icon>
        </div>
    </div>

    <div class="project_add_container">
        <div class="fz_21 fc_DEDEDE add_header" style=" padding: 48px 32px 30px 32px;">New Project</div>
        <app-basic-info></app-basic-info>
    </div>

</div>